import React from "react"
import { useParams } from "react-router-dom"
import OpportunityShareContainer from "../../containers/OpportunityShareContainer/OpportunityShareContainer"

const OpportunitySharePage = () => {
  const { uuid } = useParams()

  return <OpportunityShareContainer id={uuid} />
}

export default OpportunitySharePage
